export const EFFORT_OPTIONS = [
  { value: 'S', label: 'S — Small' },
  { value: 'M', label: 'M — Medium' },
  { value: 'L', label: 'L — Large' },
]

export const BOARD_PUBLIC_COLUMNS =
  'id, created_at, title, description, category, is_anonymous, is_pursued, created_by'

export const ADMIN_SUGGESTION_COLUMNS =
  'id, created_at, updated_at, created_by, title, description, category, is_anonymous, is_hidden, is_pursued, pursued_note, admin_notes, effort_estimate, submitter_name'
